import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import CustomerProfilePage from './CustomerProfilePage';

const HCP_TAB_INDEX = 0;

/**
 * Customer profile: Personal / Address / Licenses / Education / Password.
 * `/enduser/profile/hcp` opens the first tab (legacy deep link).
 */
export default function CustomerProfileShell() {
  return (
    <Routes>
      <Route index element={<CustomerProfilePage />} />
      <Route
        path="hcp"
        element={<CustomerProfilePage initialTabIndex={HCP_TAB_INDEX} />}
      />
      <Route path="account" element={<CustomerProfilePage />} />
      <Route
        path="*"
        element={<Navigate to="/enduser/profile/account" replace />}
      />
    </Routes>
  );
}
